import FilterChip from './FilterChip';

export default FilterChip;
